import React from "react";
import "datatables.net-bs4/js/dataTables.bootstrap4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import Breadcrumb from "./Breadcrumb";
import Bannereditcontent from "./Bannereditcontent";

export const Content = (props) => {
  return (
    <div className="ms-content-wrapper">
      <div className="row">
        <div className="col-md-12">
          <Breadcrumb />
        </div>
        <div className="col-md-12">
          <Bannereditcontent />
        </div>
      </div>
    </div>
  );
};

export default Content;
